import { message } from "antd";
import { useLanguage } from "../context/LanguageContext";
import messageTranslations from "../utils/messageContent";

const useSubscriptionService = () => {
  const { language } = useLanguage();
  const t = messageTranslations[language] || messageTranslations["de"];

  const getUserSubscription = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/getSubscription`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ token: localStorage.getItem("authToken") }),
        }
      );

      if (!response.ok) {
        throw new Error(t.subscription.fetchError);
      }

      const subscriptionData = await response.json();

      const status = subscriptionData.subscription?.status;
      console.log(status);

      if (status === "active" || status === "incomplete") {
        return "active";
      } else {
        message.info(t.subscription.noActive);
        return status || null;
      }
    } catch (error) {
      console.error("Error fetching subscription:", error.message);
      message.error(t.subscription.fetchError);
      return null;
    }
  };

  const createPortalSession = async (customerId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/subscriptions/create-portal-session`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          body: JSON.stringify({ customerId }),
        }
      );

      if (!response.ok) {
        throw new Error(t.subscription.portalError);
      }

      const sessionData = await response.json();
      return sessionData.url;
    } catch (error) {
      console.error("Error creating portal session:", error.message);
      message.error(t.subscription.portalError);
      return null;
    }
  };

  const cancelSubscription = async (customerId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/subscriptions/cancel-abo`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          body: JSON.stringify({ customerId }),
        }
      );

      if (!response.ok) {
        throw new Error(t.subscription.cancelError);
      }

      const result = await response.json();
      message.success(result.message || t.subscription.cancelSuccess);
      return result;
    } catch (error) {
      console.error("Error cancelling subscription:", error.message);
      message.error(t.subscription.cancelError);
      return null;
    }
  };

  const upgradeSubscription = async ({ customerId, newPlan, billingCycle }) => {
    const body = { customerId, newPlan, billingCycle };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/subscriptions/upgrade-abo`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          body: JSON.stringify(body),
        }
      );

      if (!response.ok) {
        throw new Error(t.subscription.upgradeError);
      }

      const result = await response.json();
      message.success(result.message || t.subscription.upgradeSuccess);
      return result;
    } catch (error) {
      console.error("Error upgrading subscription:", error.message);
      message.error(t.subscription.upgradeError);
      return null;
    }
  };

  const changeBillingCycle = async (newBillingCycle = "annual") => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/subscriptions/change-billingCycle`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          body: JSON.stringify({ newBillingCycle }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message ||
            t.subscription.billingCycleError ||
            "Fehler beim Laufzeitwechsel"
        );
      }

      const result = await response.json();
      message.success(
        result.message ||
          t.subscription.billingCycleSuccess ||
          "Laufzeit erfolgreich geändert!"
      );
      return result;
    } catch (error) {
      console.error("Error changing billing cycle:", error.message);
      message.error(
        error.message ||
          t.subscription.billingCycleError ||
          "Fehler beim Laufzeitwechsel"
      );
      return null;
    }
  };

  return {
    getUserSubscription,
    createPortalSession,
    cancelSubscription,
    upgradeSubscription,
    changeBillingCycle,
  };
};

export default useSubscriptionService;
